import { Select } from '@mantine/core'
import { removeCmOrInFromSoilProbeDepths } from 'utils/removeCmOrInFromSoilProbeDepths'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const DepthSelect = ({
  availableDepths,
  selectedDepth,
  onDepthChange,
}: {
  availableDepths: string[]
  selectedDepth: number | null
  onDepthChange: (value: string | null) => void
}) => {
  const depthOptions: {
    value: string
    label: string
  }[] = availableDepths.map((depth) => {
    const depthInCm = removeCmOrInFromSoilProbeDepths(depth)

    return {
      value: depthInCm.toString(),
      label: unitConverter.soilDepth(depthInCm).valueWithSuffix(),
    }
  })

  return (
    <Select
      w={150}
      value={selectedDepth ? `${selectedDepth}` : null}
      onChange={onDepthChange}
      data={depthOptions}
      clearable={false}
    />
  )
}
